import { ReportHeadCellData } from "@domain/Interfaces/HeadCellData.d";
import { ReportHeadCell } from "@domain/Interfaces/HeadCell.d";
import { TableHead, TableRow, TableCell, TableSortLabel, useTheme } from "@mui/material";
import Order from "@domain/Interfaces/Order.d";
import { StyledArrowSortIcon, StyledArrowUpIcon, StyledArrowDownIcon } from "@presentation/components/TotalFilterIcon";
import { useTranslation } from "react-i18next";

interface TotalScopeHeadProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof ReportHeadCellData) => void;
  order: Order;
  orderBy: string;
  headCells: ReportHeadCell[];
}

const TotalTableHead = ({ order, orderBy, onRequestSort, headCells }: TotalScopeHeadProps): JSX.Element => {
  const theme = useTheme();
  const createSortHandler = (property: keyof ReportHeadCellData) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell: ReportHeadCell) => {
          let iconComponent = StyledArrowSortIcon;
          if (orderBy === headCell.id && order === "asc") {
            iconComponent = StyledArrowUpIcon;
          } else if (orderBy === headCell.id) {
            iconComponent = StyledArrowDownIcon;
          }
          return (
            <TableCell
              key={String(headCell.id)}
              align="left"
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.enableSorting ? (
                <TableSortLabel
                  active
                  sx={{ color: orderBy === headCell.id ? theme.palette.secondary.main : "inherit" }}
                  IconComponent={iconComponent}
                  onClick={
                    headCell.enableSorting
                      ? createSortHandler(headCell.id as keyof ReportHeadCellData)
                      : () => undefined
                  }
                >
                  {headCell.label}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          );
        })}
        <TableCell align="right">{t("see_reports.headers.actions")}</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TotalTableHead;
